<div class="center-float visible">
    <button id="greeting-button" class="greeting-button-selected select-button" on:click={selectGreeting}>Greeting</button>
</div>

<div class="double-column center-float">
    <div>Message</div>
    <select class="select" bind:value={$user.selected_greeting} on:click={selectGreeting}>
        {#each $user.greeting_list || [] as greeting}
            <option value={greeting}>
                {greeting}
            </option>
        {/each}
    </select>
</div>

<style>
    .center-float {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .double-column {
        display: grid;
        grid-template-columns: auto auto;
        justify-items: start;
        gap: 1vw;
    }
</style>

<script>
    import { get } from 'svelte/store';
    import { user, state } from './data-store.js'
    import { buildMessage, switchGreetingValidation } from './common.js';

    function selectGreeting() {
        get(state).mode = 'g'
        get(state).message = buildMessage()
        switchGreetingValidation()
    }
</script>